import sneakerOne from '../../images/image-product-1.jpg';
import sneakerTwo from '../../images/image-product-2.jpg';
import sneakerThree from '../../images/image-product-3.jpg';
import sneakerFour from '../../images/image-product-4.jpg';

const images = [
  sneakerOne,
  sneakerTwo,
  sneakerThree,
  sneakerFour,
];

export default images;
